class Guest {

    static register = {};

    static avUserInfoName = 'GUEST';

}

export default Guest;